import React from "react";
import { default as MUICardActions } from "@mui/material/CardActions";
import styled from "styled-components";

const StyledMUICardActions = styled(MUICardActions)`
  :hover {
    background-color: #fff;
    color: inherit;
  }
`;

/**
 * A styled wrapper around Material UI's CardActions component.
 * Provides a container for action items like buttons at the bottom of a card.
 * Maintains white background and inherited text color on hover.
 *
 * @component
 * @param {React.ReactNode} props.children - The action items to render inside the container
 * @returns {React.ReactElement} The rendered CardActions component
 */
export const CardActions = ({ children }) => {
  return <StyledMUICardActions>{children}</StyledMUICardActions>;
};
